import Vue from 'vue'
import Component from 'vue-class-component'
import { InputStyle } from '@/store/types'
import {Prop} from 'vue-property-decorator';


/**
 * Mixin de Vue con las utilidades para aplicar estilos a la interfaz del panel
 */
@Component
export default class StyleMixin extends Vue {
    @Prop({type: String, default: 'outlined'})
    public boxStyle: string

    /**
     * Estilo actual aplicado para aplicar a los inputs
     */
    public get inputStyle (): InputStyle {
        return this.$store.state.inputStyle
    }

    public get inputStyleBind (): {[key: string]: true} {
        if (this.boxStyle) {
            return {[this.boxStyle]: true}
        }

        return {[this.inputStyle]: true}
    }
}
